// Локальные константы для компонента ServicesTester
export const DIRECT_SERVICES = [
  { 
    key: 'universe_gateway', 
    name: 'Universe Gateway', 
    url: 'http://localhost:4000', 
    healthPath: '/api/health',
    basePath: '/api',
    requiresAuth: true
  },
  { 
    key: 'imcon', 
    name: 'ImCon', 
    url: 'http://localhost:4001', 
    healthPath: '/api/health',
    basePath: '/api',
    requiresAuth: false,
    supportsImageLang: true
  },
  { 
    key: 'world_manager', 
    name: 'World Manager', 
    url: 'http://localhost:4002', 
    healthPath: '/api/health',
    basePath: '/api',
    requiresAuth: true
  },
  { 
    key: 'sim_character', 
    name: 'Sim Character', 
    url: 'http://localhost:4003', 
    healthPath: '/api/health',
    basePath: '/api',
    requiresAuth: true
  },
  { 
    key: 'character_designer', 
    name: 'Character Designer', 
    url: 'http://localhost:4004', 
    healthPath: '/api/health',
    basePath: '/api',
    requiresAuth: true
  }
];

// Методы для REST API
export const HTTP_METHODS = ['GET', 'POST', 'PUT', 'DELETE', 'PATCH'];

// Настройки логов
export const LOG_LEVELS = {
  error: true,
  warning: true,
  success: true,
  info: true,
  debug: true
};

export const LOG_FILTER_OPTIONS = [
  { value: 'all', label: 'Все' },
  { value: 'error', label: 'Ошибки' },
  { value: 'warning', label: 'Предупреждения' },
  { value: 'success', label: 'Успех' },
  { value: 'info', label: 'Информация' }
];